import { debounce } from "./debounce";
export var watchTimer = function watchTimer(_ref) {
  var bind = _ref.bind,
      _ref$interval = _ref.interval,
      interval = _ref$interval === void 0 ? 1000 : _ref$interval;
  var timer = null;

  var start = function start() {
    timer = window.setInterval(function () {
      try {
        bind();
      } catch (e) {
        stop();
      }
    }, interval);
    return timer;
  };

  var stop = function stop() {
    if (timer === null) return;
    window.clearInterval(timer);
    timer = null;
  };

  return {
    start: start,
    stop: stop
  };
};
export var watchMutation = function watchMutation(_ref2) {
  var bind = _ref2.bind,
      _ref2$interval = _ref2.interval,
      interval = _ref2$interval === void 0 ? 1000 : _ref2$interval,
      _ref2$target = _ref2.target,
      target = _ref2$target === void 0 ? window.document : _ref2$target,
      _ref2$observerConfig = _ref2.observerConfig,
      observerConfig = _ref2$observerConfig === void 0 ? {
    subtree: true,
    childList: true,
    attributes: true
  } : _ref2$observerConfig;
  var observer = new MutationObserver(debounce(function () {
    try {
      bind();
    } catch (e) {
      stop();
    }
  }, interval));

  var start = function start() {
    observer.observe(target, observerConfig);
    return null;
  };

  var stop = function stop() {
    return observer.disconnect();
  };

  return {
    start: start,
    stop: stop
  };
};
export var watchChange = function watchChange(options) {
  if (!window) return watchTimer(options);
  if (!window.MutationObserver) return watchTimer(options);
  if (options.mutationObserver) return watchMutation(options);
  return watchTimer(options);
};